import { AppState, AuthWebService, GetTokenConfig, LoginConfig, UserInfo } from '@auspost/auth0-uiim-types';
import {config} from "../config/config";
import {StorageService} from "../ap/utils/storageService";

declare global {
  interface Window {
    __AUSPOST__: {
      createAuthWebService: () => AuthWebService;
    };
  }
}
type UserDetails = {
  name: string
}
const userDetailsStorage = new StorageService<UserDetails>('USERDETAILS');

class AuthenticationService {
  private authWebService: AuthWebService;

  initialise(): Promise<AppState> {
    return this.instance.initialise(config.auth.authWebConfig);
  }

  login(config?: LoginConfig): Promise<void> {
    return this.instance.login(config);
  }

  logout(url = config.auth.loginUrl): Promise<void> {
    return this.instance.logout(url);
  }

  getAccessTokenSilently(config?: GetTokenConfig): Promise<string> {
    return this.instance.getAccessTokenSilently(config);
  }

  isAuthenticated(): Promise<boolean> {
    return this.instance.isAuthenticated();
  }

  getUser(): Promise<UserInfo | undefined> {
    return this.instance.getUser();
  }

  private get instance() {
    this.authWebService = this.authWebService || window.__AUSPOST__.createAuthWebService();
    return this.authWebService;
  }
  storeUserDetails(user: UserDetails) {
    userDetailsStorage.setItem(user);
  }
  loadUserDetails() {
    return userDetailsStorage.getItem();
  }

}

export const authenticationService = new AuthenticationService();
